import {  fetchBillableHoursForMilestone } from "components/milestone/stats/billable/api";
import { useQuery } from "@tanstack/react-query";
import { milestoneKeys } from "components/milestone/queries";

export function useMilestoneBillableHours(id) {
  return useQuery({
    queryFn: () => fetchBillableHoursForMilestone({ id }),
    queryKey: milestoneKeys.detail(id),
    select: (data) => data?.billable_hours,
    enabled: !!id,
  });
}
